import { styles } from './ErrorScreen.style';
import { useContext } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { ErrorIcon } from '@icons/ErrorIcon';
import { LocalizationContext } from 'src/Context/LocalizationContext';
import { refineFonts } from '@/Theming/refineFonts';
import { useQueryLog } from '@hooks/useQueryLog';
import { useAnalytics } from '@hooks/useAnalytics';
import { REFINE_ANALYTICS_EVENTS } from '@/types/RefineAnalyticsEvents';

export default function ErrorScreenComponent({ error }: { error: string }) {
	const { ErrorMessage: Text } = useContext(LocalizationContext);
	const { trackRefineEvent } = useAnalytics();

	trackRefineEvent(REFINE_ANALYTICS_EVENTS.GENERAL_ERROR, error);

	return (
		<Stack
			paddingInline={{
				xxs: '24px',
				xs: '24px',
				sm: '48px',
				md: '105px',
				lg: '350px',
				xl: '403px',
			}}
			paddingTop={'10%'}
			height={'100%'}
			justifyContent={'center'}
			alignItems={'center'}
			tabIndex={1}
			aria-label={`${Text.GeneralErrorTitle || "We weren't able to load the page"} ${
				Text.GeneralErrorTitle || 'Please try refreshing. If the issue continues, try again later'
			}`}
			data-cy={'pqErrorScreen'}
			direction="column"
			sx={styles.container}
			spacing={3}>
			{/* Icon */}
			<Box sx={styles.errorIcon}>
				<ErrorIcon />
				{/* Leaving this here as an example in case we will want to load up an error icon reactive to the color palette */}
				{/* <Handshake primaryColor={theme.palette.primary.main} secondaryColor={theme.palette.secondary.main} /> */}
			</Box>
			{/* Title */}

			{/* <Typography style={styles.h1}>{Text.Title || 'Thank you for your help'}</Typography> */}
			<Typography sx={{ ...refineFonts.h4Regular }}>
				{Text.GeneralErrorTitle || "We weren't able to load the page"}
			</Typography>
			{/* Subtitle */}
			<Typography sx={{ ...refineFonts.largeRegular }}>
				{Text.GeneralErrorSubtitle || 'Please try refreshing. If the issue continues, try again later'}
			</Typography>
		</Stack>
	);
}
